import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useApi from "../../hook/useApi";
import Paggination from "../Paggination";
import Loader from "../Loader/Loader";
import {
  formatDateInAMPM,
} from "../../utils/helper";
import AddCategoryModal from "../model/AddCategoryModal";

const CategoryLayer = () => {
  const { AsyncGetApiCall, AsyncPostApiCall, } = useApi();
  const [query, setQuery] = useState({
    pageNo: 1,
    limitVal: 50,
    search: "",
    status: "",
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("create");
  const [modalData, setModalData] = useState({});

  const setPageNo = (pageNo) => {
    setQuery((prev) => ({
      ...prev,
      pageNo: pageNo,
    }));
  };

  const handleModalClose = (shouldRefresh = false) => {
    setShowModal(false);
    setModalData(null);
    if (shouldRefresh) getAllNftCollectionsList();
  };

  const getAllNftCollectionsList = async (showLoader = true) => {
    try {
      if (showLoader) {
        setLoading(true);
      }
      console.log("query...", query);
      const result = await AsyncGetApiCall("/category/list", query);
      console.log("Resulst of category:", result);

      if (result?.success) {
        setData(result || []);
      } else {
        toast.error(result?.message || "Failed to fetch category data");
      }
    } catch (error) {
      console.log("error...", error);
      toast.error("An error occurred while fetching collection data");
    } finally {
      if (showLoader) {
        setLoading(false);
      }
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
  };

  const handleStatusChange = (e) => {
    const value = e.target.value;
    setQuery((prev) => ({
      ...prev,
      status: value === "Select Status" ? "" : value,
      pageNo: 1,
    }));
  };

  const handleActivateCollection = async (id, isActive) => {
    // console.log("id...", id);
    console.log("isActive...", isActive);

    try {
      setLoading(true);
      const payload = {
        categoryId: id,
        status: isActive,
      };
      const result = await AsyncPostApiCall(
        `/category/status-management`,
        payload
      );
      console.log("result...", result);
      if (result?.success) {
        toast.success(
          result?.message ||
          `Collection ${result?.data?.isActive ? "activated" : "deactivated"
          } successfully`
        );
        getAllNftCollectionsList(false);
      } else {
        toast.error(result?.message || "Something went wrong");
      }
    } catch (error) {
      console.log("error...", error);
      toast.error("An error occurred while updating collection status");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllNftCollectionsList(true);
  }, [query]);

  return (
    <>
      {loading && <Loader />}
      <div className="card h-100 p-0 radius-12">
        <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 w-100">
            <div>
              {/* Add button */}
              <button
                type="button"
                className="btn btn-primary-600 radius-8 px-17 py-9 d-flex align-items-center gap-2 ms-auto"
                onClick={() => {
                  setModalMode("create");
                  setModalData(null);
                  setShowModal(true);
                }}
                disabled={loading}
              >
                <Icon
                  icon="ic:outline-collections"
                  className="menu-icon"
                  width="24"
                  height="24"
                />
                Create Category
              </button>
            </div>
          </div>
        </div>

        <div className="card-body p-24">
          <div className="table-responsive scroll-sm">
            <table className="table bordered-table sm-table mb-0">
              <thead>
                <tr>
                  <th scope="col">
                    <div className="d-flex align-items-center gap-10">
                      <div className="form-check style-check d-flex align-items-center"></div>
                      S.No
                    </div>
                  </th>
                  <th scope="col">Name</th>
                  <th scope="col">Date</th>
                  <th scope="col">Status</th>
                  <th scope="col" className="text-center">
                    Activate
                  </th>
                  {/* <th scope="col" className="text-center">
                    Action
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {data?.data && data?.data?.length > 0 ? (
                  data?.data?.map((collection, index) => (
                    <tr key={collection?._id}>
                      <td>
                        <div className="d-flex justify-content-center align-items-center gap-10">
                          {index + 1}
                        </div>
                      </td>
                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {collection?.name}
                        </span>
                      </td>

                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {formatDateInAMPM(collection?.createdAt)}
                        </span>
                      </td>
                      <td>
                        <span
                          className={`badge ${collection?.isActive
                            ? "bg-success-100 text-success-600"
                            : "bg-danger-100 text-danger-600"
                            } text-sm py-4 px-10 radius-4`}
                        >
                          {collection?.isActive ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td className="text-center">
                        <div className="d-flex justify-content-center align-items-center gap-2">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`toggle-${collection._id}`}
                              checked={collection?.isActive}
                              onChange={() => {
                                if (
                                  window.confirm(
                                    "Are you sure you want to change the status of this collection?"
                                  )
                                ) {
                                  handleActivateCollection(
                                    collection?._id,
                                    !collection?.isActive
                                  );
                                }
                              }}
                            />
                          </div>
                        </div>
                      </td>
                      {/* <td>
                        <div className="d-flex justify-content-center align-items-center gap-2">
                          <button
                            type="button"
                            className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                            onClick={() => {
                              setModalMode("edit");
                              setModalData(collection);
                              setShowModal(true);
                            }}
                          >
                            <Icon icon="lucide:edit" className="menu-icon" />
                            <span className="tooltip-text">Edit</span>
                          </button>
                        </div>
                      </td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center">
                      No categories found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <Paggination
            total={data?.total || 0}
            totalPages={data?.totalPages || 0}
            currentPage={data?.currentPage || 0}
            setPageNo={setPageNo}
            startFrom={(data?.currentPage - 1) * query.limitVal + 1}
            endTo={
              (data?.currentPage - 1) * query.limitVal +
              (data?.data?.length || 0)
            }
          />

          <AddCategoryModal
            show={showModal}
            handleClose={handleModalClose}
            mode={modalMode}
            data={modalData}
          />
        </div>
      </div>
    </>
  );
};

export default CategoryLayer;
